export default __webpack_public_path__ + "static/media/gif2.d0597336.png";